/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_ButtonInputs */

const fr_membership_friend_guest_button = /** @type {(inputs: Membership_Friend_Guest_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter un ami`)
};

/**

* @param {Membership_Friend_Guest_ButtonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_button = /** @type {((inputs?: Membership_Friend_Guest_ButtonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_ButtonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_button(inputs)
});